import React from 'react';
import { InstagramIcon } from 'lucide-react';
export function ContactSection() {
  return <footer className="border-t border-ivory/15 bg-ink px-5 pb-7 pt-14 sm:px-8 lg:px-12 lg:pb-8 lg:pt-20" data-id="element-5" data-mp="2z91uxtbm6nu9">
      <div className="mx-auto max-w-[1600px]" data-id="element-6" data-mp="2kkf3it8pq5mo">
        <div className="max-w-3xl" data-id="element-7" data-mp="2khkjh2tm2mts">
          <p className="text-lg font-light leading-relaxed text-ivory/65 sm:text-xl" data-id="element-8" data-mp="2pigvk3o49faa">
            <span className="font-medium text-ivory" data-id="element-9" data-mp="3d8b80k4ix1u0">Get in touch</span> for technology
            partnerships, co-production opportunities, or further information
            regarding the production.
          </p>
          <div className="mt-6 flex flex-col items-start gap-4" data-id="element-10" data-mp="34861sdb2g9hf">
            <a href="mailto:dop2026live@gmail.com" className="inline-block border-b border-sage/50 pb-2 text-sm tracking-[0.12em] text-ivory transition-colors duration-500 hover:border-sage hover:text-sage focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sage" data-id="element-11" data-mp="349zarz95j5sl">
              dop2026live@gmail.com
            </a>
            <a href="https://www.instagram.com/doorsofperceptionlive" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 text-sm tracking-[0.08em] text-ivory/55 transition-colors duration-500 hover:text-sage focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sage" aria-label="Follow The Doors of Perception on Instagram" data-id="element-12" data-mp="7moh5fb6d09d">
              <InstagramIcon className="h-4 w-4 transition-transform duration-500 group-hover:scale-110" aria-hidden="true" data-id="element-13" data-mp="lmfst9e7y4k7" />
              @doorsofperceptionlive
            </a>
          </div>
        </div>

        <div className="mt-14 border-t border-ivory/10 pt-5" data-id="element-14" data-mp="vdty5xsupyl9">
          <p className="text-[10px] uppercase tracking-[0.22em] text-ivory/35" data-id="element-15" data-mp="19cjsx6s77m6g">
            © Improbable Arts
          </p>
        </div>
      </div>
    </footer>;
}